import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface ChevronDroitMediumProps extends pictoProps {
}

export interface ChevronDroitMediumState extends pictoState {
}

export class ChevronDroitMediumPicto extends Picto<ChevronDroitMediumProps,ChevronDroitMediumState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.chevronDroitMediumPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(ChevronDroitMediumPicto);
